<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees
		class="row py-5"
		[addable]="isAddable"
		(addEvent)="openModalAjout()"
		[isImportable]="isImportable"
		(importingEvent)="uploader.click()"
		[isExportable]="isExportable"
		(exportingEvent)="exportEmployees()"
	></app-nav-gestion-donnees>

	<input hidden type="file" #uploader (change)="importEmployees($event)" />

	<div class="row my-3">
		<div class="row my-2">
			<div class="col-auto">
				<button
					class="btn theme-main-color-button"
					(click)="importFromOcashe()"
				>
					<i class="bi bi-cloud-download" aria-hidden="true"></i> Importer
					depuis OCASHE
				</button>
			</div>
			<div class="col-2 ms-lg-auto">
				<div class="dropdown">
					<a
						class="btn btn-secondary dropdown-toggle"
						role="button"
						id="dropdownFilter"
						data-bs-toggle="dropdown"
						data-bs-auto-close="outside"
						aria-expanded="false"
					>
						<i class="bi bi-filter" aria-hidden="true"></i> Filtrer
					</a>
					<div
						class="dropdown-menu px-3 py-3"
						aria-labelledby="dropdownFilter"
						id="menuFilter"
					>
						<div class="row">
							<span class="theme-main-color form-label">Compétence(s) :</span>
							<div class="">
								<div *ngFor="let competence of competences" class="form-check">
									<input
										(change)="changeCompetencesFilter($event, competence.name)"
										class="form-check-input"
										type="checkbox"
										value="{{ competence.name }}"
										id="dd{{ competence.name }}"
									/>
									<label class="form-check-label" for="dd{{ competence.name }}">
										{{ competence.name.replaceAll('_', ' ') }}
									</label>
								</div>
							</div>
						</div>
						<div class="row">
							<span class="theme-main-color form-label">Spécialité(s)</span>
							<div class="row vw-30 ms-0">
								<div
									class="col-4 form-check"
									*ngFor="let specialite of listSpecialite"
								>
									<input
										type="checkbox"
										name="{{ specialite.id }}"
										class="form-check-input"
										[value]="specialite"
										(change)="updateSelectedSpecialite($event, specialite)"
									/>
									<label class="form-check-label text-dark">
										{{ specialite.name }}
									</label>
								</div>
							</div>
						</div>
						<div class="row">
							<span class="theme-main-color form-label">Service(s)</span>
							<div class="row vw-30 ms-0">
								<div
									class="col-4 form-check"
									*ngFor="let department of centerDepartments"
								>
									<input
										type="checkbox"
										name="{{ department.id }}"
										class="form-check-input"
										[value]="department"
										(change)="updateSelectedDepartment($event, department)"
									/>
									<label class="form-check-label text-dark">
										{{ department.name }}
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-3 col-12 ps-lg-5">
				<div class="input-group">
					<span class="input-group-text bg-transparent"
						><i class="bi bi-search" aria-hidden="true"></i
					></span>
					<input
						type="text"
						class="form-control border-start-0"
						placeholder="Recherche un élément..."
						[(ngModel)]="searchedText"
					/>
				</div>
			</div>
		</div>

		<div *ngIf="!isMobile" class="row mt-4">
			<!-- Colonne intervenant -->
			<div class="col-2" [ngClass]="{ 'col-3': !isAreaActive }">
				<span class="hand-cursor fw-bold" (click)="sortChange('lastName')">
					{{ LABEL_INTERVENANT_CAPITALIZED }}
					<span
						*ngIf="sortType === 'lastName' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'lastName' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<!-- Colonne Type d'employé -->
			<div class="col-lg-1 col-2" [ngClass]="{ 'col-2': !isAreaActive }">
				<span class="hand-cursor fw-bold" (click)="sortChange('type')">
					Type
					<span
						*ngIf="sortType === 'type' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'type' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<!-- Colonne secteurs -->
			<div *ngIf="isAreaActive" class="col-2">
				<span
					class="hand-cursor fw-bold"
					(click)="sortChange('employee.areas')"
				>
					Secteur(s)
					<span
						*ngIf="sortType === 'employee.areas' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'employee.areas' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<!-- Colonne services -->
			<div class="col-2">
				<span
					class="hand-cursor fw-bold"
					(click)="sortChange('employee.centerDepartments')"
				>
					Service(s)
					<span
						*ngIf="
							sortType === 'employee.centerDepartments' && sortOrder === 'asc'
						"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="
							sortType === 'employee.centerDepartments' && sortOrder === 'desc'
						"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<!-- Colonne compétence -->
			<div class="col-2">
				<span
					class="hand-cursor fw-bold"
					(click)="sortChange('careSkill.name')"
				>
					Compétence
					<span
						*ngIf="sortType === 'careSkill.name' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'careSkill.name' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<!-- Colonne spécialités -->
			<div class="col-2 col-lg-2" [ngClass]="{ 'col-2': !isAreaActive }">
				<span
					class="ms-0 me-5 hand-cursor fw-bold"
					(click)="sortChange('specialties[0].name')"
				>
					Spécialité(s)
					<span
						*ngIf="sortType === 'specialties[0].name' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'specialties[0].name' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
		</div>

		<div class="mt-4" *ngIf="isListingLoading">
			<app-loading></app-loading>
		</div>

		<div *ngIf="!isListingLoading" class="mt-4">
			<div
				*ngFor="
					let employee of employees
						| filterEmployeeBySkill : selectedCompetences
						| filterEmployeeByAllFields : searchedText
						| filterEmployeeBySpecialties : listSelectedSpecialite
						| filterEmployeeByDepartment : listSelectedDepartment
						| paginate
							: {
									itemsPerPage: itemsPerPage,
									currentPage: currentPage
							  }
						| orderBy : sortType : sortOrder
				"
				class="row my-1 pt-3 py-2 pb-1 rounded rounded-3 bg-light"
			>
				<!-- Colonne intervenant -->
				<div class="col-lg-2 col-2" [ngClass]="{ 'col-lg-3': !isAreaActive }">
					<span *ngIf="isMobile" class="fw-bold">Intervenant : </span>
					<span
						*ngIf="hasValidColor(employee)"
						class="color-circle"
						[ngStyle]="{
							'background-color': colorsPastel[employee.colorIndex]?.secondary
						}"
					>
					</span>

					{{ employee.firstName }} {{ employee.lastName }}
				</div>
				<!-- Colonne type d'employé -->
				<div
					class="col-lg-1 col-2 p-lg-0"
					[ngClass]="{ 'col-3': !isAreaActive }"
				>
					<span *ngIf="isMobile" class="fw-bold">Type : </span
					>{{ employeeTypeString[employee.type] }}
				</div>
				<!-- Colonne secteurs -->
				<div *ngIf="isAreaActive" class="col-lg-2 col-2">
					<span *ngIf="isMobile" class="fw-bold">Secteur(s) : </span>
					<span *ngIf="employee.areas">
						<span *ngFor="let area of employee.areas; last as isLast">
							<span>{{ area.name }} <span *ngIf="!isLast">- </span></span>
						</span>
					</span>
					<span style="font-style: italic" *ngIf="employee.areas.length === 0"
						>Non-renseigné</span
					>
				</div>
				<!-- Colonne services -->
				<div class="col-lg-2 col-2">
					<span *ngIf="isMobile" class="fw-bold">Service(s) : </span>
					<span *ngIf="employee.centerDepartments">
						<span
							*ngFor="
								let department of employee.centerDepartments;
								last as isLast
							"
						>
							<span>{{ department.name }} <span *ngIf="!isLast">- </span></span>
						</span>
					</span>
					<span
						style="font-style: italic"
						*ngIf="employee.centerDepartments.length === 0"
						>Non-renseigné</span
					>
				</div>
				<!-- Colonne compétence -->
				<div class="col-lg-2 col-2 p-lg-0">
					<span *ngIf="isMobile" class="fw-bold">Compétence : </span>
					{{ getEmployeeSkillsAsString(employee) }}
				</div>
				<!-- Colonne spécialité -->
				<div
					class="col-lg-2 col-2 d-flex p-lg-0"
					[ngClass]="{ 'col-lg-6': !isAreaActive }"
				>
					<div class="flex-grow-1">
						<span *ngIf="isMobile" class="fw-bold"> Spécialité(s) : </span>
						<span
							*ngFor="let spe of employee.specialties; let ilast = last"
							class="me-1"
						>
							{{ spe && ' ' + spe.name }}{{ spe && (ilast ? '' : ',') }}
						</span>

						<span *ngIf="employee.specialties.length === 0" class="me-1">
							Sans
						</span>
					</div>
					<i
					(click)="openEmployee(employee.id)"
						role="button"
						class="fs-4 bi bi-caret-right-fill mb-1 me-2"
						aria-hidden="true"
					></i>
				</div>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<pagination-controls
			class="d-flex justify-content-center"
			(pageChange)="currentPage = $event"
			previousLabel="Précédent"
			nextLabel="Suivant"
		>
		</pagination-controls>
		<div class="d-flex justify-content-center">
			<label class="form-label mt-2 mx-2">Elements par page</label>
			<div class="">
				<select
					[(ngModel)]="itemsPerPage"
					#ctrl="ngModel"
					(change)="currentPage = 1"
					[ngModelOptions]="{ standalone: true }"
					class="form-select"
				>
					<option [value]="5">5</option>
					<option *ngIf="employees?.length >= 5" [value]="10">10</option>
					<option *ngIf="employees?.length >= 10" [value]="25">25</option>
					<option *ngIf="employees?.length >= 25" [value]="50">50</option>
					<option *ngIf="employees?.length >= 50" [value]="100">100</option>
				</select>
			</div>
		</div>
	</div>
</div>
